import Vue from "vue";
import dayjs from "dayjs";

Vue.filter("fmt-time", time => {
    return dayjs(time).format("YYYY MM-DD HH:mm:ss");
});
